import { render, staticRenderFns } from "./UpdateSousTypeCreneau.vue?vue&type=template&id=70df5a9e&"
import script from "./UpdateSousTypeCreneau.vue?vue&type=script&lang=ts&"
export * from "./UpdateSousTypeCreneau.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports